import { render, staticRenderFns } from "./FixturesMatch.vue?vue&type=template&id=32c625c3&scoped=true&"
import script from "./FixturesMatch.vue?vue&type=script&lang=js&"
export * from "./FixturesMatch.vue?vue&type=script&lang=js&"
import style0 from "./FixturesMatch.vue?vue&type=style&index=0&id=32c625c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c625c3",
  null
  
)

export default component.exports